module.exports = __webpack_public_path__ + "img/icon_general.f9fb0b66.svg";